export const IMAGE_EXTENSIONS = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp', 'svg'];

const EXTENSION_ICON_MAP: Record<string, string> = {
    pdf: 'pdf',
    jpg: 'file-image', jpeg: 'file-image', png: 'file-image', gif: 'file-image',
    bmp: 'file-image', webp: 'file-image', svg: 'file-image', ico: 'file-image',
    tiff: 'file-image', tif: 'file-image',
    doc: 'file-word', docx: 'file-word', odt: 'file-word', rtf: 'file-word',
    xls: 'file-excel', xlsx: 'file-excel', ods: 'file-excel', csv: 'file-excel',
    ppt: 'file-powerpoint', pptx: 'file-powerpoint', odp: 'file-powerpoint',
    mp4: 'file-video', avi: 'file-video', mkv: 'file-video', mov: 'file-video',
    wmv: 'file-video', flv: 'file-video', webm: 'file-video',
    mp3: 'file-audio', wav: 'file-audio', ogg: 'file-audio', flac: 'file-audio',
    aac: 'file-audio', wma: 'file-audio', m4a: 'file-audio',
    zip: 'file-archive', rar: 'file-archive', '7z': 'file-archive',
    tar: 'file-archive', gz: 'file-archive', bz2: 'file-archive',
    txt: 'file-text', log: 'file-text', md: 'file-text', json: 'file-text',
    xml: 'file-text', html: 'file-text', css: 'file-text',
    js: 'file-text', ts: 'file-text', yml: 'file-text', yaml: 'file-text',
};

export function getFileIcon(extension: string): string {
    return EXTENSION_ICON_MAP[(extension || '').toLowerCase()] ?? 'file-generic';
}

export function isImageExtension(extension: string): boolean {
    return IMAGE_EXTENSIONS.includes((extension || '').toLowerCase());
}
